import React from "react";
import { Link } from "react-router-dom";

const CourierChips = ({
  couriers = [],
  basePath = "couriers",
  emptyText = "No couriers",
}) => {
  if (!couriers.length) {
    return <span className="small text-secondary">{emptyText}</span>;
  }

  return (
    <div className="d-flex flex-wrap gap-1" aria-label="Couriers">
      {couriers.map((c) => (
        <Link
          key={c.id}
          to={`${basePath}/${c.id}`}
          title={`View ${c.name} details`}
          className={`badge rounded-pill text-decoration-none border fw-normal px-2 py-1 ${
            c.isActive === false
              ? "text-secondary bg-body-secondary"
              : "text-body bg-body"
          }`}
        >
          {c.name}
        </Link>
      ))}
    </div>
  );
};

export default CourierChips;
